export function getByOnSale(foods) {
  const arr = foods.filter((food) => food.FoodSaleStatusType === 0);
  return arr;
}

export default { getByOnSale };
